import React from "react";
import edit from "../../../../assets/img/admin/edit.svg";
import trash from "../../../../assets/img/admin/trash-2.svg";
import Button from "../../../shared/Button";
import img from "../../../../assets/img/Home/Rectangle 23.png";
import useFetch from "../../../../hooks/useAxios";
import toast from "react-hot-toast";
const SpecialistWagerow = ({ code, title,id, img ,perc,setCodeWageMessage,
  setCodeWageEdit,apiWageList}) => {
    const EditFunc = ()=>{
      setCodeWageMessage({
        residence_code:code ,
        wage_percentage:perc,
        id:id
      })

      setCodeWageEdit(true);
    }
    const delWageForAll = useFetch({
      method: "post",
      url: `api/admin/wages/delete/${id}`,
      noHeader: false,
      trigger: false,
      caller:apiWageList,
      argFunc:res=>{
          toast.success("کارمزد پاک شد.")
      },
      errMessage:err=>{
          toast.error(err.message)
      }
    });
  
    const deletefunc=()=>{
      delWageForAll.reFetch()
    }
  return (
    <div>
      <div className="SpecialistWagerow flex items-center justify-between">
        <div className="flex items-center  gap-[20px]">
          <img src={img} className=" rounded-[26px] w-[200px] h-[120px]" />
          <div>
            <div className=" rounded-[8px] px-[16px] py-[4px]  text-[16px] bg-[#F0F0F0]">
              کد آگهی :{code}
            </div>
            <h3 className="text-[20px] text-[#12171C] mt-[30px]">
              {title}
            </h3>
          </div>
        </div>
        <div className="flex gap-[24px] items-center">
          <button>
            <img src={trash} onClick={deletefunc} />
          </button>
          <button onClick={EditFunc}>
            <img src={edit} />
          </button>
          <Button varient="primary">{perc}% کارمزد</Button>
        </div>
      </div>
    </div>
  );
};
const SpecialistWage = ({WageList,setCodeWageMessage,setCodeWageEdit,apiWageList}) => {
  return (
    <div>
      <h4 className="text-[36px] text-[#12171C] font-[700] my-[36px] ">
        کارمزد های اختصاصی
      </h4>

      <div className="SpecialistWage" >
       {WageList.by_residence.map(i=>
       <SpecialistWagerow
       code={234566}
       img={img}
       key={i.id}
       id={i.id}
       title={i.residence_title}
       setCodeWageMessage={setCodeWageMessage}
       setCodeWageEdit={setCodeWageEdit}
       perc={i.wage_percentage}
       apiWageList={apiWageList}
     />
       ) 
}
      </div>
    </div>
  );
};

export default SpecialistWage;
